export const forSuccessListing = [
	{
		icon: '💑',
		title: 'forSuccessData_title1',
		subtitle: 'forSuccessData_subtitle1',
	},
	{
		icon: '💰',
		title: 'forSuccessData_title2',
		subtitle: 'forSuccessData_subtitle2',
	},
	{
		icon: '💪',
		title: 'forSuccessData_title3',
		subtitle: 'forSuccessData_subtitle3',
	},
	{
		icon: '🛍️',
		title: 'forSuccessData_title4',
		subtitle: 'forSuccessData_subtitle4',
	},
];
